import Vue from "vue";
import App from "./App.vue";

Vue.config.productionTip = false;

new Vue({
    data: {
        bucket_url: "https://s3.amazonaws.com/thefanexam.com"
    },
    render: h => h(App)
}).$mount("#app");
